import { Container, Row } from "react-bootstrap";
import { formatDate } from "../_helpers";
import { HeaderDetailItem } from "./HeaderDetailItem";
import { VendorPurchaseOrderItem } from "../_types";

export interface PurchaseOrderItemMessagingHeaderProps {
  headerData: VendorPurchaseOrderItem;
}

export function PurchaseOrderItemMessagingHeader({
  headerData,
}: PurchaseOrderItemMessagingHeaderProps) {
  return (
    <Container fluid>
      <Row>
        <HeaderDetailItem
          label="Purchase Order #"
          value={headerData.purchaseOrderNumber}
        />
        <HeaderDetailItem
          label="Line Item #"
          value={headerData.lineItemNumber}
        />
        <HeaderDetailItem label="Priority" value={headerData.priority ?? ""} />
        <HeaderDetailItem
          label="Qty"
          value={`${headerData.quantity} ${headerData.unitOfMeasure}`}
        />
        <HeaderDetailItem
          label="Original Due Date"
          value={
            headerData.originalDueDate
              ? `${formatDate(headerData.originalDueDate)} `
              : ""
          }
        />
        <HeaderDetailItem
          label="Modified Due Date"
          value={formatDate(headerData.modifiedDueDate)}
        />
        <HeaderDetailItem
          label="# Times Due Date Changed"
          value={headerData.timesDueDateChanged}
        />
      </Row>

      <Row>
        <HeaderDetailItem
          label="Description of Work"
          value={headerData.description}
        />
      </Row>
    </Container>
  );
}
